/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Support_TitleInputs */

const en_support_title = /** @type {(inputs: Support_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support SSC`)
};

const es_support_title = /** @type {(inputs: Support_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apoya a SSC`)
};

const fr_support_title = /** @type {(inputs: Support_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soutenir SSC`)
};

const de_support_title = /** @type {(inputs: Support_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SSC unterstützen`)
};

const id_support_title = /** @type {(inputs: Support_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dukung SSC`)
};

/** @type {(inputs: Support_TitleInputs) => LocalizedString} */
const ja_support_title = en_support_title;

/** @type {(inputs: Support_TitleInputs) => LocalizedString} */
const zh_support_title = en_support_title;

/** @type {(inputs: Support_TitleInputs) => LocalizedString} */
const ar_support_title = en_support_title;

/** @type {(inputs: Support_TitleInputs) => LocalizedString} */
const it_support_title = en_support_title;

/** @type {(inputs: Support_TitleInputs) => LocalizedString} */
const ru_support_title = en_support_title;

/** @type {(inputs: Support_TitleInputs) => LocalizedString} */
const pt_support_title = en_support_title;

/** @type {(inputs: Support_TitleInputs) => LocalizedString} */
const ko_support_title = en_support_title;

/**
* | output |
* | --- |
* | "Support SSC" |
*
* @param {Support_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const support_title = /** @type {((inputs?: Support_TitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Support_TitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_support_title(inputs)
	if (locale === "es") return es_support_title(inputs)
	if (locale === "fr") return fr_support_title(inputs)
	if (locale === "de") return de_support_title(inputs)
	if (locale === "ja") return ja_support_title(inputs)
	if (locale === "zh") return zh_support_title(inputs)
	if (locale === "ar") return ar_support_title(inputs)
	if (locale === "id") return id_support_title(inputs)
	if (locale === "it") return it_support_title(inputs)
	if (locale === "ru") return ru_support_title(inputs)
	if (locale === "pt") return pt_support_title(inputs)
	return ko_support_title(inputs)
});